// Base container for the app.
// data Pulled from Azure, sorted as required and passed to each component
// Component are then built into the app if there is data associated.
import React, { useContext, useState } from "react";
import { Context } from "../Store";
import { useParams, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Players from "../components/Players";
import ActionReplays from "../components/ActionReplays";
import GroupPhotos from "../components/GroupPhotos";
import Games from "../components/Games";
import Loopcams from "../components/Loopcams";
import CopyLinkContainer from "../components/CopyLinkContainer/CopyLinkContainer";
import LoadingStory from "../components/LoadingStory";
import { getVenueName } from "../utils/venues";
import { getStoryData } from "../utils/storyData";
import { openLightbox, updateLightbox, handleHover, updatePreview } from "../utils/storyUIHandlers";
import { StoriesAzureAPI, country } from "../utils/getStoriesAzureApi";
import Share from "../components/Share";
import NextVisit from "../components/NextVisit";
import GroupPhotosNew from "../components/GroupPhotosNew";

const StoryContainer = () => {
  // Setting app context to Store.js Where the overall state is kept
  const [state, setState] = useContext(Context);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const debug = params.get("debug");

  console.log(state, "state in StoryContainer");

  // On load will use the string after the first slash (/) as the GUID
  // to request Stories data from the Azure API. Will work both with or without the trailing #/ in the URL
  let { guid } = useParams();

  // Check if state has been set. If not get data from guid and set display to "Loading"
  if (state.guid.length < 1) {
    getStoryData({ id: guid, country, StoriesAzureAPI, debug, getVenueName, setState, state });
    return (
      <div>
        <LoadingStory />
      </div>
    );
  }

  return (
    <div>
      <Context.Provider value={state}>
        <Header />
        <Players openLightbox={openLightbox} />
        {state.actionReplays.length >= 1 && <ActionReplays handleHover={handleHover} openLightbox={openLightbox} />}
        <Share />
        {/* {state.groupPhotos.length >= 1 && <GroupPhotos handleHover={handleHover} openLightbox={openLightbox} />} */}
        {state.groupPhotos.length >= 1 && <GroupPhotosNew handleHover={handleHover} openLightbox={openLightbox} />}

        {state.games.length >= 1 && <Games handleHover={handleHover} openLightbox={openLightbox} />}
        {state.loopcams.length >= 1 && <Loopcams handleHover={handleHover} openLightbox={openLightbox} />}

        <NextVisit />
        <CopyLinkContainer mount={updatePreview} callbackHandler={openLightbox} updateLightbox={updateLightbox} />
      </Context.Provider>
    </div>
  );
};

export default StoryContainer;
